module.exports = __webpack_public_path__ + "img/trend-up.1cbee08a.svg";